import React from 'react';
import { createRetryableLazy } from '../utils/lazyLoading';

// Route-based code splitting - Main application pages
export const LazyDashboards = {
  OpsRecruiterDashboard: createRetryableLazy(
    () => import('../components/dashboards/OpsRecruiterDashboard')
  ),
  RecruitingManagerDashboard: createRetryableLazy(
    () => import('../components/dashboards/RecruitingManagerDashboard')
  ),
  BackOfficeDashboard: createRetryableLazy(
    () => import('../components/dashboards/BackOfficeDashboard')
  ),
  ClientSuccessDashboard: createRetryableLazy(
    () => import('../components/dashboards/ClientSuccessDashboard')
  ),
  ComplianceAdminDashboard: createRetryableLazy(
    () => import('../components/dashboards/ComplianceAdminDashboard')
  )
};

// Core application pages
export const LazyPages = {
  CandidateDiscovery: createRetryableLazy(
    () => import('../components/CandidateDiscovery')
  ),
  JobPosting: createRetryableLazy(
    () => import('../components/JobPosting')
  ),
  UserManagement: createRetryableLazy(
    () => import('../components/UserManagement')
  ),
  AgentTestPage: createRetryableLazy(
    () => import('../components/AgentTestPage')
  ),
  SearchTestPage: createRetryableLazy(
    () => import('../components/SearchTestPage')
  )
};

// Test pages for development
export const LazyTestPages = {
  TestPageNavigation: createRetryableLazy(
    () => import('../components/test-pages/TestPageNavigation')
  ),
  DesignSystemTestPage: createRetryableLazy(
    () => import('../components/test-pages/DesignSystemTestPage')
  ),
  DashboardTestPage: createRetryableLazy(
    () => import('../components/test-pages/DashboardTestPage')
  ),
  AgentInteractionTestPage: createRetryableLazy(
    () => import('../components/test-pages/AgentInteractionTestPage')
  ),
  SearchSystemTestPage: createRetryableLazy(
    () => import('../components/test-pages/SearchSystemTestPage')
  ),
  CommunicationTestPage: createRetryableLazy(
    () => import('../components/test-pages/CommunicationTestPage')
  ),
  TouchInteractionTestPage: createRetryableLazy(
    () => import('../components/test-pages/TouchInteractionTestPage')
  ),
  DeviceIntegrationTestPage: createRetryableLazy(
    () => import('../components/test-pages/DeviceIntegrationTestPage')
  ),
  ChartLibraryTestPage: createRetryableLazy(
    () => import('../components/test-pages/ChartLibraryTestPage')
  )
};

// Advanced features that can be loaded on demand
export const LazyFeatures = {
  AdvancedAnalytics: createRetryableLazy(
    () => import('../components/analytics/AdvancedAnalytics')
  ),
  DataVisualization: createRetryableLazy(
    () => import('../components/charts/DataVisualization')
  ),
  ReportBuilder: createRetryableLazy(
    () => import('../components/reports/ReportBuilder')
  ),
  WorkflowAutomation: createRetryableLazy(
    () => import('../components/automation/WorkflowAutomation')
  ),
  IntegrationManager: createRetryableLazy(
    () => import('../components/integrations/IntegrationManager')
  )
};

// Heavy components that should be lazy loaded
export const LazyComponents = {
  // Chart components
  InteractiveChart: createRetryableLazy(
    () => import('../components/charts/InteractiveChart')
  ),
  DataTable: createRetryableLazy(
    () => import('../components/tables/DataTable')
  ),
  
  // AI components
  AIInsightPanel: createRetryableLazy(
    () => import('../components/ai/AIInsightPanel')
  ),
  ConversationInterface: createRetryableLazy(
    () => import('../components/ai/ConversationInterface')
  ),
  
  // Media components
  VideoPlayer: createRetryableLazy(
    () => import('../components/media/VideoPlayer')
  ),
  ImageGallery: createRetryableLazy(
    () => import('../components/media/ImageGallery')
  ),
  
  // Editor components
  RichTextEditor: createRetryableLazy(
    () => import('../components/editors/RichTextEditor')
  ),
  CodeEditor: createRetryableLazy(
    () => import('../components/editors/CodeEditor')
  )
};